import { render, staticRenderFns } from "./productGroups.vue?vue&type=template&id=3c6cae9d&scoped=true"
import script from "./productGroups.vue?vue&type=script&lang=js"
export * from "./productGroups.vue?vue&type=script&lang=js"
import style0 from "./productGroups.vue?vue&type=style&index=0&id=3c6cae9d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6cae9d",
  null
  
)

export default component.exports